class GeekoLoadMore extends HTMLElement {
  constructor() {
    super();
    this.data_page_count=0;
    this.addEventListener('click', this.loadMoreProducts.bind(this));
    this.next_url = document.getElementById('product-grid').dataset.nextUrl;
    this.loadMoreBtn = this.querySelector('.button');
    if (this.loadMoreBtn) this.loadMoreBtn.style.display = 'none';
    this.loading = false;

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) this.loadMoreProducts();
      });
    }, { rootMargin: '200px 0px' });
    this.observer.observe(this);

  }
  async getNextPage() {
    try {
      let res = await fetch(this.next_url);
      return await res.text();
    } catch (error) {
      console.log(error);
    } 
  }
  async loadMoreProducts() {
    if (this.loading || !this.next_url) return;
    this.loading = true;
    const load_more_spinner = this.getElementsByClassName('load-more_spinner')[0];
    if (this.loadMoreBtn) this.loadMoreBtn.style.display = 'none';
    load_more_spinner.style.display = 'block';
    let nextPage = await this.getNextPage();
    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
    load_more_spinner.style.display = 'none';
    const productgrid = nextPageDoc.getElementById('product-grid');
    const new_products = productgrid.getElementsByClassName('grid__item');
    const temp = new_products;
    const new_url = productgrid.dataset.nextUrl;
    // if (new_url) {
    //   if (this.loadMoreBtn) this.loadMoreBtn.style.display = 'inline-flex';
    // }
    this.next_url = new_url;
    let currentIndex = 0;
    while (new_products.length > currentIndex) {
      let product = new_products[currentIndex];
      if(product.classList.contains('wbimgbnrblock')) {
        currentIndex++;
        continue;
      };
      document.getElementById('product-grid').appendChild(product);
    } 
    this.loading = false;
    this.data_page_count=this.data_page_count+1;
    if (!this.next_url && this.observer) {
      this.observer.disconnect();
      reutrn;
    }
    if(this.data_page_count>=3){
      if(this.observer){
        this.observer.disconnect();
      }
      if(this.next_url){
        if (this.loadMoreBtn) this.loadMoreBtn.style.display = 'inline-flex';
      }
    }
  }
  //必须加：组件从 DOM 移除时自动清理 observer
  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
customElements.define('geeko-load-more', GeekoLoadMore);